/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for restoring to an AWS Keyspaces table.
*/
export class AwsKeyspacesDestination {
  /**
  * Name of the keyspace to restore the table into.
  */
  'keyspaceName': string;
  /**
  * Name to assign to the restored table.
  */
  'tableName': string;
  /**
  * Region to restore to.
  */
  'region': string;
  /**
  * ID of the key you want Eon to use for encrypting the restored resource.
  */
  'encryptionKeyId': string;
  /**
  * Tags to apply to the restored table as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "keyspaceName",
      "baseName": "keyspaceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "tableName",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsKeyspacesDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

